import React, {useEffect} from 'react';

// Modules
import type {FunctionComponent} from 'react';
import {useRouter} from 'next/router';

// Config
import {config} from '@app/modules/config';
import {getISOLocaleFromLocale} from '@deezer/deezer-compatibility';

import type {ConsentScreenApi} from '@tempo/cookie';
import {CookieBanner} from '@tempo/cookie';
import {logCenter} from '@modules/tracking/logCenter';
import {useAppState} from '@app/modules/apps/context';
import {useClientId} from '@app/hooks/useClient';
import {useAutolog} from '@app/hooks/auth/useAutolog';
import {AuthStatus} from '@app/hooks/auth/useAutolog/utils';

// Window type upersede
declare global {
	interface Window {
		consentScreenApi?: ConsentScreenApi;
		onDzrGDPRReady?: (initApi: () => Promise<ConsentScreenApi>) => unknown;
	}
}

export const ConsentScreen: FunctionComponent = () => {
	const {locale} = useRouter();
	const {data, status} = useAutolog();
	const {isOauth} = useAppState();
	const clientId = useClientId();

	useEffect(() => {
		if (isOauth) {
			logCenter.log({
				type: 'cdp',
				eventName: 'screen_view',
				customAttributes: {
					screen_view_name: 'oauth_cookie_deezer',
					screen_view_id: clientId,
				},
			});
		}
	}, []);

	if (status === AuthStatus.loading || status === AuthStatus.missinginfo) {
		return null;
	}

	const gdprLang = getISOLocaleFromLocale(locale ?? 'en-US');

	return (
		<CookieBanner
			scriptUrl={`${config.get('commonAssetsUrl')}/js/gdpr-appliance.js`}
			userID={String(data?.user_id) ?? '0'}
			lang={gdprLang}
			cookieDomain={config.get('cookieDomain')}
			gatewayHost={config.get('deezerApiUrl')}
		/>
	);
};
